import { trackEvent } from './tracking';

// Types
import { Workspace } from 'Shared/types/Workspace.type';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useApp } from 'Shared/utils/hooks/use-app';

type Props = {
  workspace?: Workspace;
};

export const useAgendaBuilderTracking = ({ workspace }: Props) => {
  const { id: currentUserId } = useCurrentUser();
  const { appId } = useApp();

  const track = ({ eventName, properties = {} }) => {
    const propertiesToSend = {
      product_feature: 'Workspace Agenda Builder',
      user: currentUserId,
      app_id: appId,
      workspace_id: workspace.id,
      ...properties,
    };

    trackEvent(eventName, propertiesToSend);
  };

  const trackViewedWorkspaceAgendaBuilder = ({ showingTemplates }: { showingTemplates: boolean }) => {
    track({
      eventName: 'Viewed Workspace Agenda Builder',
      properties: { showingTemplates },
    });
  };

  const trackClickedCreateNewTemplate = ({ hasOtherTemplates }: { hasOtherTemplates: boolean }) => {
    track({
      eventName: 'Clicked Create New Template',
      properties: { hasOtherTemplates },
    });
  };

  return {
    trackViewedWorkspaceAgendaBuilder,
    trackClickedCreateNewTemplate,
  };
};
